module.exports = __webpack_public_path__ + "static/whitedinosaursuitcase-67f58c6e9e16129fe8d8b2cc3ea47a42.jpeg";